import { configureStore } from '@reduxjs/toolkit'
import filterSlice from '../features/jobs/filterSlice'
import jobSlice from '../features/jobs/jobSlice'

export const store = configureStore({
  reducer: {
    jobs:jobSlice,
    filter:filterSlice
  },
})